<span
  data-e2e="basket-status-badge"
  class="
    d-inline-flex
    align-items-center
    justify-content-center
    basket-status-badge
  "
  [class]="statusClass"
>
  {{ translations[value] || value | titlecase }}
</span>
